module.exports = __webpack_public_path__ + "img/news_post_8.5a8c9afc.jpg";